// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountsAlternateRequestModel {
    static getAttributeTypeMap() {
        return SiteAccountsAlternateRequestModel.attributeTypeMap;
    }
}
SiteAccountsAlternateRequestModel.discriminator = undefined;
SiteAccountsAlternateRequestModel.additionalProperties = false;
SiteAccountsAlternateRequestModel.attributeTypeMap = [
    {
        "name": "description",
        "baseName": "description",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "portalId",
        "baseName": "portalId",
        "type": "string"
    },
    {
        "name": "maxRecordCount",
        "baseName": "maxRecordCount",
        "type": "number"
    },
];
//# sourceMappingURL=siteAccountsAlternateRequestModel.js.map